import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { colors } from '../../colors'

import sanitizeHtml from 'sanitize-html';

import { Pagination } from '../../components/pagination'
import { Button } from '../../components/button'
import { NewsPaperFeedCard } from '../../components/newPaperFeedCard'

import { NavBar } from '../../components/navbar'
import { Footer } from '../../components/footer'


import { NewsSearch, ButtonContainer, DateInput, Publications } from '../nigerianapub'
import { InputContainer } from '../signup'
import { NewspaperData } from '../../newspaperdata'

import {
  InnerContainer,
  ImageContainer,
} from '../../components/newPaperFeedCard'

import { useDispatch, useSelector } from 'react-redux'
import { getRecentExternal } from '../../pages/features/public/publicSlice'


const ExternalResources = () => {
  const [convertedText, setConvertedText] = useState("Some default content");
  

  const dispatch = useDispatch()
    
    const { publicResources, publicStatus} = useSelector(state => state.publicResources);

    useEffect(() => {

        dispatch(getRecentExternal());

    }, [publicStatus, dispatch]);

  return (
    <Container>
      <NavBar />
      
      <BodyContainer>
        <h2>Open Access Publications</h2>
        <p>Below are the latest open access resources </p>

        
          <NewsSearch>
          <div>
                    <form>
                        <h5>Search Open Access Publications</h5>
                        <InputContainer>
                            
                            <input type="search" placeholder='Title' />
                        </InputContainer>

                        <InputContainer>
                            
                            <input type="search" placeholder='Author' />
                        </InputContainer>

                        <InputContainer>
                            
                            <input type="search" placeholder='Keyword' />
                        </InputContainer>
                        
                        {/* <InputContainer>
                            
                            <input type="search" placeholder='NLN Code' />
                        </InputContainer> */}


                        <InputContainer>
                            
                            <select name="" id="">
                                <option value="">Select a category</option>
                                
                                {
                                  publicResources.map((external) => {
                                    return (
                                      <option value="">{external.resourceCategory}</option>
                                    )
                                  } )
                                }
                            </select>
                        </InputContainer>

                        

                        <ButtonContainer>
                            <Button filled bgColor={'#2A870E'} noIcon text={'Search'} />
                            
                        </ButtonContainer>

                    </form>

                    <div>

                        <h5>Sort Search Result</h5>
                            <InputContainer>
                                <label htmlFor="date">Sort by year</label>
                                <DateInput>
                                    <input name='date' type="search" placeholder='From' />
                                    <input name='date' type="search" placeholder='To' />
                                </DateInput>
                            </InputContainer>

                            <InputContainer>
                                <label htmlFor="date">Sort Alphabetically</label>
                                <select name="" id="">
                                    <option value="">A-Z</option>
                                    <option value="">Z-A</option>
                                </select>
                            
                            </InputContainer>
                    </div>

                </div>

                <Publications>

                <NewsCards>

                  {
                    publicResources.map((external) => {
                      return (
                        <LinkToDetails key={external?.resourceId} to={`/open-access/resource/${external.resourceNlnCode}`} >
                          <InnerContainer>
                            <ImageContainer src={external?.resourceImage} alt='newspaper_icon' />
                             <Title>
                              <h4>
                                {external?.resourceTitle}
                              </h4> 
                              <h5 dangerouslySetInnerHTML={{ __html: sanitizeHtml(external?.resourceDescription?.substring(0, 100)) }} />
                             </Title>
                             
                          </InnerContainer>
                          </LinkToDetails>
                      )
                    }

                  )}

                </NewsCards>

                </Publications>

                {/* <NewsPaperFeedCard /> */}

          </NewsSearch>

        
          

          <Pagination />
      </BodyContainer>

      <Footer />
    </Container>
  )
}

const Container = styled.section`
  
`

const BodyContainer = styled.div`
  width: 90%;
  max-width: 1250px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
  flex-wrap: wrap;

  &  select{
        background-color: inherit;
        border: 2px solid #D0D5DD;
        border-radius: 4px;
        height: 32px;
        padding: 0 10px;

        & > option{
            height: 30px;
        }
    }

    @media screen and (max-width: 600px){
        width: 90%;

    }
`

const InnerSearch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`

const NewsCards = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  /* border: 1px solid red; */
  
  @media screen and (max-width: 600px){
    width: 100%;
  }
`

const LinkToDetails = styled(Link)`
    text-decoration: none;
    color: #000;
`

const Title = styled.div`

    padding-left: 20px;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    
    & h4{
        align-self: flex-start;
        font-weight: 600;
    }

    & > h5{
        align-self: flex-start;
        font-size: 12px;
        color: ${colors.faint_text};

        & > p{
            font-size: 12px;
        }
    }
`




export {ExternalResources}